import PromoCodesList from "./PromoCodesList";

export default PromoCodesList;
